import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useRef, useCallback, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useController } from '@/hooks/useController';
import { LightBox } from '@/newComponents/LightBox';
import { imageLoadedState } from '@/state/session';
export const Image = ({ name, url }) => {
    const { notifyWebviewOpened, notifyWebviewClosed } = useController();
    const [imageLoaded, setImageLoaded] = useRecoilState(imageLoadedState);
    const [isLinkBroken, setIsLinkBroken] = useState(false);
    const ref = useRef(null);
    const [open, setOpen] = useState(false);
    const onLoad = useCallback(() => {
        setImageLoaded(true);
    }, [setImageLoaded]);
    useEffect(() => {
        if (ref.current && ref.current.complete && !imageLoaded) {
            onLoad();
        }
    }, [imageLoaded, onLoad]);
    useEffect(() => {
        setImageLoaded(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageLoaded]);
    const handleImageOpen = useCallback(() => {
        notifyWebviewOpened();
        setOpen(true);
    }, [notifyWebviewOpened]);
    const handleImageClose = useCallback(() => {
        notifyWebviewClosed();
        setOpen(false);
    }, [notifyWebviewClosed]);
    return (_jsxs(_Fragment, { children: [_jsx(Dialog, { open: open, children: _jsx(DialogContent, { onInteractOutside: (e) => e.preventDefault(), onEscapeKeyDown: (e) => e.preventDefault(), className: cn('h-full w-full bg-black p-0'), children: _jsx(LightBox, { onClose: handleImageClose, url: url }) }) }), _jsx("button", { className: cn("image-btn" /* TestClassName.ImageButton */, 'block max-w-md cursor-pointer border-0 bg-transparent p-0'), onClick: handleImageOpen, children: _jsx("img", { className: cn('block w-full max-w-full rounded-[var(--moveo-border-radius-base)]', {
                        'max-h-[88px]': isLinkBroken, // $space-22 = 88px
                    }), src: url, alt: name, ref: ref, onLoad: onLoad, onError: () => setIsLinkBroken(true) }) })] }));
};
